export default __webpack_public_path__ + "static/media/meetingRoom.08843343.jpeg";